import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { meaningfulLegacyPlacement } from '../../utils/locationDisplay';
import type { CameraPlacementLookup } from '../../utils/locationDisplay';

type Props = {
  siteDisplayName?: string | null;
  siteId?: string | null;
  placement?: CameraPlacementLookup;
  canWrite: boolean;
  onEdit: () => void;
};

/** Site / Area / Mount row with — / Set location (Epic 281-B). */
export const CameraLocationPath: React.FC<Props> = ({
  siteDisplayName,
  siteId,
  placement,
  canWrite,
  onEdit,
}) => {
  const siteLabel = meaningfulLegacyPlacement(siteDisplayName)
    || meaningfulLegacyPlacement(siteId);
  const areaLabel = meaningfulLegacyPlacement(placement?.areaName)
    || meaningfulLegacyPlacement(placement?.areaId);
  const mountLabel = meaningfulLegacyPlacement(placement?.mountLabel);
  const path = meaningfulLegacyPlacement(placement?.path)
    || [siteLabel, areaLabel, mountLabel].filter(Boolean).join(' / ');
  const hasPlacement = Boolean(areaLabel || mountLabel || meaningfulLegacyPlacement(placement?.path));

  return (
    <Box sx={{ mb: 0.5 }}>
      <Typography variant="body2" color="text.secondary" component="span">
        <strong>Site / Area / Mount:</strong>{' '}
        {hasPlacement ? path : '—'}
      </Typography>
      {canWrite && (
        <Button
          size="small"
          sx={{ ml: 1, minWidth: 0, textTransform: 'none' }}
          onClick={onEdit}
        >
          {hasPlacement ? 'Edit location' : 'Set location'}
        </Button>
      )}
    </Box>
  );
};

export default CameraLocationPath;
